import { assertValidVersion } from "@tsparticles/engine";
import { StarDrawer } from "./StarDrawer.js";
export async function loadStarShape(engine, refresh = true) {
    assertValidVersion(engine, "3.7.1");
    await engine.addShape(new StarDrawer(), refresh);
}
